import {
  initialState,
  Actions,
  State,
  GET_ONE_ELEMENT,
  GET_ONE_ELEMENT_SUCCESS,
  GET_ONE_ELEMENT_ERROR,
  RESET_GET_ONE_ELEMENT,
} from '../../types/element/get-one'

const reducers = (state = initialState, action: Actions<any>): State<any> => {
  switch (action.type) {
    case GET_ONE_ELEMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_ELEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_ELEMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_ELEMENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
